<template>
    <div class="container">

        <Loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="false"></Loading>

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>
                    <span v-if="editMode">Urejanje orodja</span>
                    <span v-if="!editMode">Dodajanje orodja</span>
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <b-form-group
                        label="Vnesi ime"
                        label-for="name"
                        :class="{'is-invalid': errors.has('name')}">
                    <b-form-input id="name" name="name" v-model="tool.name" v-validate="'required'" trim></b-form-input>

                    <div class="invalid-feedback" v-if="errors.has('name')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>

                <b-form-group
                        label="Vnesi opis orodja"
                        label-for="description"
                        :class="{'is-invalid': errors.has('description')}">
                    <b-form-textarea id="description" name="description" v-model="tool.description"
                                     v-validate="'required'" trim></b-form-textarea>
                    <div class="invalid-feedback" v-if="errors.has('description')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>

                <b-form-group
                        id="link"
                        label="Če obstaja, vnesi povezavo na opis orodja na spletu (npr. mimovrste, spletna stran proizvajalca)"
                        label-for="link">
                    <b-form-input id="link" v-model="tool.link" trim></b-form-input>
                </b-form-group>

                <b-form-group
                        id="notes"
                        label="Vnesi opombe (npr. stanje ohranjenosti, zaloga potrošnega materiala in rezervnih delov)"
                        label-for="notes">
                    <b-form-textarea id="description" v-model="tool.notes" trim></b-form-textarea>
                </b-form-group>

                <b-form-group
                        label="Določi v katero katergorijo orodje sodi"
                        label-for="project"
                        :class="{'is-invalid': errors.has('category')}">

                    <v-select
                            v-model="tool.category"
                            placeholder="kategorija"
                            id="category"
                            name="category"
                            :options="categories"
                            label="name"
                            :reduce="item => item.id"
                            v-validate="'required'"
                    >
                        <span slot="no-options">Ni zadetkov.</span>
                        <template slot="option" slot-scope="item">
                            {{item.name}}
                        </template>
                        <template slot="selected-option" slot-scope="item">
                            {{item.name}}
                        </template>

                    </v-select>
                    <div class="invalid-feedback" v-if="errors.has('category')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>

                <b-form-group
                        label="Slika orodja"
                        label-for="photo"
                        :class="{'is-invalid': errors.has('photo')}">

                    <b-form-input id="photo" name="photo" class="d-none" v-model="tool.photo" v-validate="'required'" trim></b-form-input>

                    <div class="invalid-feedback" v-if="errors.has('photo')">
                        Slika mora biti obvezno dodana.
                    </div>

                    <div v-if="!imageData && tool.photo">
                        <div class="card" style="width: 200px;">
                            <div class="card-img">
                                <img class="preview img-fluid" :src="tool.photo">
                            </div>
                        </div>
                        <div class="mt-1">
                            <a class="btn btn-primary btn-sm text-white" @click="(e) => { imgEditMode = true; }">Zamenjaj
                                sliko</a>
                        </div>
                    </div>


                    <div v-if="imgEditMode || !tool.photo">
                        <div>
                            <input type="file" @change="previewImage" accept="image/*">

                        </div>
                        <div v-if="imageData">
                            <p>Nalaganje: {{uploadValue.toFixed()+"%"}}
                                <progress id="progress" :value="uploadValue" max="100"></progress>
                            </p>
                        </div>
                        <div v-if="imageData!=null">
                            <img class="preview" :src="picture" style="width: 200px;">
                        </div>
                    </div>

                </b-form-group>

                <b-form-group
                        label="Trenutna lokacija orodja"
                        label-for="location"
                        :class="{'is-invalid': errors.has('location')}">

                    <v-select
                            v-model="tool.location"
                            placeholder="location"
                            id="location"
                            name="location"
                            :options="users"
                            label="displayName"
                            :reduce="item => item.id"
                            v-validate="'required'"
                    >
                        <span slot="no-options">Ni zadetkov.</span>
                        <template slot="option" slot-scope="item">
                            {{item.displayName}}
                        </template>
                        <template slot="selected-option" slot-scope="item">
                            {{item.displayName}}
                        </template>

                    </v-select>
                    <div class="invalid-feedback" v-if="errors.has('location')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>

                <b-form-group
                        label="Kontaktna oseba"
                        label-for="contactPerson"
                        :class="{'is-invalid': errors.has('contactPerson')}">

                    <v-select
                            v-model="tool.contactPerson"
                            placeholder="contactPerson"
                            id="contactPerson"
                            name="contactPerson"
                            :options="getPeople"
                            label="name"
                            :reduce="item => item.name"
                            v-validate="'required'"
                    >
                        <span slot="no-options">Ni zadetkov.</span>
                        <template slot="option" slot-scope="item">
                            {{item.name}}
                        </template>
                        <template slot="selected-option" slot-scope="item">
                            {{item.name}}
                        </template>

                    </v-select>
                    <div class="invalid-feedback" v-if="errors.has('contactPerson')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>


            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3">
                <div class="d-flex">
                    <button v-if="editMode" class="btn btn-danger mr-auto" @click="deleteToolConfirmation()"><i
                            class="fa fa-trash"></i>
                        Izbriši
                        orodje
                    </button>

                    <button v-if="!editMode" type="submit" @click="addTool()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Shrani podatke o orodju
                    </button>


                    <button v-if="editMode" type="submit" @click="updateTool()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Posodobi podatke o orodju
                    </button>
                </div>

                <div>

                    <router-link :to="{ name: 'Tools'}" class="btn btn-link pt-4">
                        Prekliči
                    </router-link>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import firebase from 'firebase'
    import {db} from '../main'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'

    export default {
        name: 'EditUser',
        components: {
            vSelect,
            Loading
        },
        data() {
            return {
                tool: {
                    id: null,
                    name: '',
                    description: '',
                    notes: '',
                    category: '',
                    photo: '',
                    link: '',
                    location: '',
                    contactPerson: '',
                    deleted: false,
                    updatedAt: null,
                    updatedBy: '',
                    createdAt: null,
                    createdBy: null,
                },
                id: this.$route.params.id,
                editMode: false,
                currentUser: null,

                imageUploadInProgress: false,
                imageData: null,
                picture: null,
                uploadValue: 0,

                categories: [],
                users: [],
                contactPersons: [],
                imgEditMode: false,

                isLoading: false
            }
        },

        firestore() {
            if (this.id) {
                return {
                    categories: db.collection('categories'),
                    tool: db.collection('tools').doc(this.id),
                    users: db.collection('users')
                }
            } else {
                return {
                    categories: db.collection('categories'),
                    users: db.collection('users')
                }
            }
        },

        computed: {

            getPeople() {
                let people = [];

                _.map(this.users, function (item) {
                    _.each(item.people, function (innerItem) {
                        people.push(innerItem);
                    });
                });

                people = _.sortBy(people, function (item) {
                    return item.name;
                });

                return people;
            }
        },

        mounted() {

            if (this.id) {
                this.editMode = true;
                this.tool.location = this.tool.location ? this.tool.location : JSON.parse(sessionStorage.getItem('HRAM_user')).displayName;
            } else {
                this.editMode = false
                this.tool.location = JSON.parse(sessionStorage.getItem('HRAM_user')).displayName;
            }

            this.users.push({
                id: -1,
                displayName: 'na drugi lokaciji'
            });

        },
        methods: {

            updateTool(id) {
                const _this = this
                const currentUser = db.collection('tools').doc(this.id);

                this.$validator.validate().then(result => {
                    if (result) {
                        _this.isLoading = true;

                        return currentUser.update({
                            name: _this.tool.name,
                            description: _this.tool.description,
                            notes: _this.tool.notes,
                            category: _this.tool.category,
                            link: _this.tool.link,
                            photo: _this.picture ? _this.picture : _this.tool.photo,
                            location: _this.tool.location ? _this.tool.location : JSON.parse(sessionStorage.getItem('HRAM_user')).displayName,
                            contactPerson: _this.tool.contactPerson,
                            updatedAt: new Date(),
                            updatedBy: JSON.parse(sessionStorage.getItem('HRAM_user')).id,
                            createdAt: _this.tool.createdAt,
                            createdBy: _this.tool.createdBy
                        })
                            .then(function () {
                                _this.isLoading = false;
                                _this.$store.dispatch('retrieveTools', true).then(() => {
                                    _this.$router.push('/orodja')
                                })
                            })
                            .catch(function (error) {
                                // The document probably doesn't exist.
                                console.error('Error updating tool: ', error);
                                _this.isLoading = false;
                            })
                    } else {
                        _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
                    }
                });



            },

            addTool() {
                const _this = this

                this.$validator.validate().then(result => {
                    if (result) {
                        let ref = db.collection('tools').doc()
                        ref.set({id: ref.id}) // set new document ID
                            .then(() => {  // fetch the doc again and show its data
                                ref.get().then(doc => {

                                    _this.id = doc.data().id
                                    _this.tool.createdAt = new Date()
                                    _this.tool.createdBy = JSON.parse(sessionStorage.getItem('HRAM_user')).id
                                    _this.updateTool()
                                })
                            })
                    } else {
                        _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
                    }
                });


            },
            deleteToolConfirmation() {
                const _this = this

                this.$swal({
                    title: 'Opozorilo',
                    text: 'Ali ste prepričani, da želite izbrisati orodje ' + _this.tool.name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
                    dangerMode: true,
                    buttons: {
                        cancel: {
                            text: 'Prekliči',
                            value: null,
                            visible: true,
                            className: '',
                            closeModal: true,
                        },
                        confirm: {
                            text: 'Izbriši',
                            value: true,
                            visible: true,
                            className: '',
                            closeModal: true
                        }
                    },
                })
                    .then((value) => {

                        switch (value) {

                            case true:

                                _this.deleteTool()

                            case null:

                                return

                                break

                            default:

                        }
                    })
            },
            deleteTool() {
                const _this = this

                db.collection('tools').doc(_this.id).delete()
                    .then(function () {
                        _this.$router.push('/orodja')
                    })
                    .catch(function (error) {
                        // The document probably doesn't exist.
                        console.error('Error deleting tool: ', error)
                    })
            },

            previewImage(event) {
                this.uploadValue = 0;
                this.picture = null;
                this.imageData = event.target.files[0];
                this.onUpload();
                console.log("HERE!!!");
            },

            onUpload() {
                this.picture = null;
                this.imageUploadInProgress = true;
                const storageRef = firebase.storage().ref(`tools/${this.imageData.name}`).put(this.imageData);
                storageRef.on(`state_changed`, snapshot => {
                        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    }, error => {
                        console.log(error.message)
                    },
                    () => {
                        this.uploadValue = 100;
                        storageRef.snapshot.ref.getDownloadURL().then((url) => {
                            this.picture = url;
                            this.imageData = null;
                            this.tool.photo = url;
                            this.imageUploadInProgress = false;
                        });
                    }
                );
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/EditTool.vue